import SetUpSuccess from 'features/payLater/screens/SetUpSuccess/SetUpSuccess';

export default function Page() {
  return <SetUpSuccess />;
}
